{
  "common": {
    "appName": "FLOWTIFY",
    "save": "Salvar",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "continue": "Continuar",
    "back": "Voltar",
    "close": "Fechar",
    "yes": "Sim",
    "no": "Não",
    "loading": "Carregando...",
    "search": "Pesquisar",
    "select": "Selecionar",
    "edit": "Editar",
    "delete": "Excluir",
    "create": "Criar",
    "language": "Idioma"
  },
  "toasts": {
    "loadSellersError": "Erro ao carregar vendedores, tente novamente.",
    "invalidCredentials": "Usuário ou senha inválido, tente novamente.",
    "selectSeller": "Selecione um Seller",
    "loginError": "Erro ao fazer login, tente novamente.",
    "success": "Sucesso",
    "error": "Erro",
    "warning": "Atenção",
    "accessDenied": "Acesso Negado"
  },
  "nav": {
    "dashboard": "Dashboard",
    "labels": "Etiquetas",
    "orders": "Pedidos",
    "qrScanner": "Scanner QR",
    "invoices": "Faturas",
    "production": "Produção",
    "productGroup": "Grupo de Produtos",
    "users": "Usuários",
    "settings": "Configurações",
    "integrations": "Integrações",
    "mlStub": "Stub do ML",
    "logout": "Sair",
    "tip": {
      "dashboard": "Dashboard: Visualize gráficos e cards estratégicos",
      "labels": "Etiquetas: Imprima e gerencie etiqueta das suas vendas",
      "orders": "Pedidos: Visualize os pedidos do seller por período",
      "qrScanner": "Scanner QR Code: Use seu celular como scanner",
      "invoicesRegularize": "Faturas: Regularize sua fatura",
      "invoices": "Faturas: Visualize e gerencie suas faturas",
      "production": "Produção: Acompanhe sua produção",
      "productGroup": "Produção: Acompanhe e crie sua ordem produção",
      "users": "Usuários Internos: Gerencie usuários internos do sistema",
      "settings": "Configurações: Configure as parametrizações do sistema",
      "integrations": "Integrações: Gerencie os marketplaces conectados à sua conta",
      "mlStub": "Stub do Mercado Livre: simule pedidos, envios e falhas (só em desenvolvimento)",
      "logout": "Sair da aplicação"
    }
  },
  "header": {
    "seller": "Seller:",
    "selectAccount": "Selecione uma conta",
    "blockedAccess": "Acesso bloqueado",
    "blockedMessage": "Você tem fatura(s) vencida(s) há mais de 7 dias. Regularize para continuar acessando o sistema.",
    "invoiceOverdueOne": "Fatura Vencida",
    "invoiceOverdueMany": "Faturas Vencidas",
    "riskInterruption": "Risco de interrupção do serviço",
    "invoiceDueTodayOne": "Fatura Vencendo Hoje",
    "invoiceDueTodayMany": "Faturas Vencendo Hoje",
    "dueTodayWarning": "Atenção: vencimento hoje",
    "invoiceUpcomingOne": "Fatura Vencendo em Breve",
    "invoiceUpcomingMany": "Faturas Vencendo em Breve",
    "upcomingInfo": "Faturas que vão vencer nos próximos dias"
  },
  "dialog": {
    "switchAccountTitle": "Trocar de Conta",
    "switchAccountMessage": "Você está prestes a trocar de conta.\n\nIsso vai deslogar a conta atual.\n\nDeseja continuar?"
  },
  "login": {
    "welcome": "Bem-vindo",
    "subtitle": "Faça login para continuar",
    "tabMl": "Mercado Livre",
    "tabPassword": "Usuário e Senha",
    "mlDescription": "Entre com sua conta do Mercado Livre de forma rápida e segura",
    "mlButton": "Login com Mercado Livre",
    "tabShopee": "Shopee",
    "shopeeDescription": "Entre com sua conta da Shopee de forma rápida e segura",
    "shopeeButton": "Login com Shopee",
    "username": "Usuário",
    "usernamePlaceholder": "Digite seu usuário",
    "password": "Senha",
    "passwordPlaceholder": "Digite sua senha",
    "selectSeller": "Selecionar Vendedor",
    "enter": "Entrar",
    "forgotPassword": "Esqueci minha senha"
  },
  "users": {
    "tabUsers": "Usuários",
    "tabProfiles": "Perfis",
    "usersTitle": "Usuários Internos",
    "profilesTitle": "Perfis",
    "newUser": "Novo Usuário",
    "newProfile": "Novo Perfil",
    "emptyUsers": "Nenhum usuário encontrado.",
    "emptyProfiles": "Nenhum perfil encontrado.",
    "edit": "Editar",
    "delete": "Deletar",
    "validated": "Validado",
    "notValidated": "Não Validado",
    "active": "Ativo",
    "inactive": "Inativo",
    "confirmDeleteTitle": "Confirmar Exclusão",
    "confirmDeleteUser": "Tem certeza que deseja excluir o usuário {{email}}?\n\nEsta ação é um soft delete e o usuário não aparecerá mais na lista.",
    "confirmDeleteProfile": "Tem certeza que deseja excluir o perfil {{name}}?\n\nEsta ação é um soft delete e o perfil não aparecerá mais na lista.",
    "col": {
      "email": "Email",
      "emailValidated": "Email Validado",
      "profiles": "Perfis",
      "createdAt": "Criado em",
      "actions": "Ações",
      "name": "Nome",
      "description": "Descrição",
      "status": "Status"
    },
    "toast": {
      "loadUsersError": "Erro ao carregar usuários.",
      "noCreatePermission": "Você não tem permissão para criar usuários.",
      "noEditPermission": "Você não tem permissão para editar usuários.",
      "noDeletePermission": "Você não tem permissão para deletar usuários.",
      "userDeleted": "Usuário excluído com sucesso",
      "userDeleteError": "Erro ao excluir usuário.",
      "loadProfilesError": "Erro ao carregar perfis.",
      "profileDeleted": "Perfil excluído com sucesso",
      "profileNotFound": "Perfil não encontrado.",
      "profileDataError": "Dados inválidos. Erro ao processar o perfil.",
      "profileGenericError": "Ocorreu um erro ao processar o perfil, tente novamente.",
      "loadProfilesListError": "Erro ao carregar lista de perfis.",
      "loadUserError": "Erro ao carregar o usuário.",
      "userCreated": "Usuário criado com sucesso!",
      "userUpdated": "Usuário atualizado com sucesso!",
      "userNotFound": "Usuário não encontrado.",
      "emailInUse": "Este email já está em uso.",
      "userDataError": "Dados inválidos. Erro ao processar o usuário.",
      "userGenericError": "Ocorreu um erro ao processar o usuário, tente novamente.",
      "loadPermissionsError": "Erro ao carregar árvore de permissões.",
      "loadProfileError": "Erro ao carregar o perfil.",
      "profileCreated": "Perfil criado com sucesso!",
      "profileUpdated": "Perfil atualizado com sucesso!"
    },
    "form": {
      "editUser": "Editar Usuário",
      "createUser": "Criar Usuário",
      "emailPlaceholder": "usuario@exemplo.com",
      "emailRequired": "O email é obrigatório.",
      "emailInvalid": "Email inválido.",
      "password": "Senha",
      "passwordPlaceholder": "Mínimo 6 caracteres",
      "passwordRequired": "A senha é obrigatória.",
      "passwordMin": "A senha deve ter no mínimo 6 caracteres.",
      "confirmPassword": "Confirmar Senha",
      "confirmPasswordPlaceholder": "Confirme a senha",
      "confirmRequired": "A confirmação de senha é obrigatória.",
      "passwordsMismatch": "As senhas não coincidem.",
      "selectProfiles": "Selecione os perfis",
      "profilesHint": "Selecione um ou mais perfis para vincular ao usuário",
      "editProfile": "Editar Perfil",
      "createProfile": "Criar Perfil",
      "name": "Nome",
      "namePlaceholder": "Nome do perfil",
      "nameRequired": "O nome é obrigatório.",
      "nameMin": "O nome deve ter no mínimo 3 caracteres.",
      "description": "Descrição",
      "descriptionPlaceholder": "Descrição do perfil (opcional)",
      "permissions": "Permissões",
      "loadingPermissions": "Carregando permissões...",
      "selectAtLeastOnePermission": "Deve selecionar pelo menos uma permissão.",
      "profileActive": "Perfil Ativo"
    }
  },
  "integrations": {
    "title": "Integrações",
    "subtitle": "Gerencie as integrações conectadas à sua conta.",
    "loading": "Carregando integrações...",
    "loadError": "Não foi possível carregar as integrações.",
    "active": "Ativo",
    "inactive": "Inativo",
    "cannotDisable": "Integração obrigatória — não pode ser desativada."
  },
  "breadcrumb": {
    "home": "Início",
    "labelPrint": "Impressão de Etiquetas",
    "checklist": "Conferência",
    "noPermission": "Sem permissão",
    "page": "Página"
  },
  "health": {
    "summary": {
      "healthy": "Serviços operando",
      "degraded": "Serviços instáveis",
      "unhealthy": "Serviços com falha",
      "unknown": "Verificando serviços"
    },
    "message": {
      "healthy": "Todos os serviços estão operando normalmente.",
      "issue": "Um ou mais serviços apresentam instabilidade.",
      "unknown": "Verificando o status dos serviços."
    },
    "status": {
      "healthy": "Operando",
      "degraded": "Instável",
      "unhealthy": "Falha",
      "unknown": "Não verificado"
    },
    "tooltipOk": "Serviços 100% operando.",
    "tooltipIssue": "Serviços com instabilidade.",
    "services": {
      "database": "Banco de dados",
      "messaging": "Mensageria",
      "mercadoLivre": "Mercado Livre",
      "availability": "Disponibilidade",
      "authentication": "Autenticação"
    },
    "lastCheck": "Última verificação:",
    "waiting": "Aguardando..."
  },
  "settings": {
    "title": "Configurações",
    "theme": "Tema",
    "themeHint": "Escolha entre claro, escuro ou seguir o sistema",
    "configurePrinters": "Configurar impressoras",
    "readOnly": "Você está visualizando esta tela em modo somente leitura. Não possui permissão para editar configurações.",
    "printerName": "Nome da Impressora",
    "printerNamePlaceholder": "Digite o nome da impressora",
    "printFormat": "Formato de Impressão",
    "printTest": "Imprimir teste",
    "loadingPrinters": "Carregando impressoras...",
    "online": "Online",
    "offline": "Offline",
    "noPrinters": "Nenhuma impressora encontrada.",
    "loadPrintersError": "Não foi possível carregar a lista de impressoras.",
    "toast": {
      "noEditPermission": "Você não tem permissão para editar configurações.",
      "saved": "Configurações salvas com sucesso!",
      "saveError": "Ocorreu um erro ao salvar as configurações, tente novamente!",
      "enterPrinterName": "Por favor, insira o nome da impressora.",
      "selectPrinterToTest": "Selecione uma impressora para testar.",
      "testSent": "Impressão de teste enviada.",
      "testFailed": "Falha ao enviar a impressão de teste.",
      "testError": "Erro ao imprimir teste."
    }
  },
  "labels": {
    "title": "IMPRESSÃO DE ETIQUETAS",
    "todayCount": "Etiquetas impressas hoje: {{count}}",
    "orderIdPlaceholder": "Leia o QRCode ou digite o número da venda",
    "stopCamera": "Parar Câmera",
    "useCamera": "Usar Câmera",
    "cameraDenied": "Permissão da câmera negada. Por favor, permita o acesso à câmera nas configurações do navegador.",
    "mobileScanner": "Scanner Mobile",
    "waitingMobile": "Aguardando mobile...",
    "viewQrCode": "Ver QR Code",
    "deactivate": "Desativar",
    "activate": "Ativar",
    "connectMobile": "Conectar Mobile",
    "scanToConnect": "Escaneie este QR Code no seu celular para conectar:",
    "sessionQrAlt": "QR Code da Sessão",
    "howToUse": "Como usar:",
    "step1a": "Faça login em",
    "step1b": "no seu celular",
    "step2a": "Vá no menu",
    "step2b": "Scanner QR Code",
    "step3a": "Clique em",
    "step3b": "Escanear QR Code da Sessão",
    "step4": "Escaneie o QR Code acima",
    "waitingConnect": "Aguardando mobile conectar...",
    "fetchingData": "Buscando dados da etiqueta no Mercado Livre.....",
    "sendingPrint": "Enviando etiqueta para impressão.....",
    "sentToPrinter": "Etiquetas enviadas para impressora",
    "saleNumber": "Número da Venda",
    "action": "Ação",
    "dateTime": "Data/Hora",
    "observation": "Observação",
    "clickToIssue": "Clique para emitir",
    "reprint": "Reimprimir",
    "reprintHint": "Reenviar esta etiqueta para a impressora",
    "revokeDevice": "Desconectar",
    "stationCode": "Código da estação",
    "pairingCodeExpiresIn": "Expira em {{seconds}}s",
    "pairingCodeExpired": "Código expirado. Gere um novo.",
    "newPairingCode": "Gerar novo código",
    "pairStep1": "Aponte a câmera do celular para o QR Code acima",
    "pairStep2": "Toque no link que aparecer na tela",
    "pairStep3": "Digite abaixo o número de 6 dígitos que aparecer no celular",
    "pairStep4": "Pronto — pode começar a bipar",
    "pairNoLogin": "Não é preciso fazer login no celular.",
    "typeConfirmationCode": "Código que apareceu no celular",
    "confirmationPlaceholder": "000000",
    "confirmPairing": "Confirmar",
    "confirmationHint": "Só o aparelho que leu o QR Code mostra esse número.",
    "deviceWaiting": "{{device}} está aguardando confirmação.",
    "loadingMoreLogs": "Carregando mais logs...",
    "viewOnMl": "Ver no mercado livre",
    "toast": {
      "titleScanner": "Scanner Mobile",
      "titleError": "Erro",
      "titleSuccess": "Sucesso",
      "titleAccessDenied": "Acesso Negado",
      "mobileConnected": "Mobile conectado: {{name}}",
      "mobileDisconnected": "Mobile desconectado",
      "sessionDisconnected": "Sessão desconectada",
      "qrReceived": "QR Code recebido do mobile: {{data}}",
      "noPrintPermission": "Você não tem permissão para imprimir etiquetas.",
      "labelSent": "Etiqueta enviada para impressora",
      "printError": "Ocorreu um erro ao imprimir a etiqueta, verifique se a impressora está conectada.",
      "printErrorAction": "Erro ao imprimir etiqueta",
      "labelFetchError": "Não foi possível obter a etiqueta no Mercado Livre, tente novamente, ou imprima manual pelo painel do Mercado Livre.",
      "labelFetchErrorAction": "Erro ao obter etiqueta",
      "invoiceNotIssued": "Nota fiscal não emitida",
      "invoiceIssuedWaiting": "Nota Fiscal foi emitida, Aguardando para enviar etiqueta pra impressão.",
      "invoiceIssueError": "Não foi possível emitir a nota fiscal, tente pelo portal do Mercado Livre.",
      "qrDetected": "QR Code detectado: {{id}}",
      "scannerModeOn": "Modo scanner mobile ativado",
      "scannerModeOnError": "Erro ao ativar modo scanner mobile",
      "scannerModeOff": "Modo scanner mobile desativado",
      "scannerModeOffError": "Erro ao desativar modo scanner mobile",
      "pairingCodeError": "Não foi possível gerar um novo código de pareamento.",
      "deviceRevoked": "Celular desconectado da estação.",
      "pairingConfirmed": "Celular pareado com sucesso.",
      "pairingConfirmError": "Não foi possível confirmar o pareamento.",
      "qrGenError": "Erro ao gerar QR Code"
    }
  },
  "orders": {
    "startDate": "Data Inicial",
    "endDate": "Data Final",
    "shippingStatus": "Status de Envio",
    "clear": "Limpar",
    "search": "Pesquisar",
    "totalOrders": "Total de Pedidos:",
    "printerOffline": "Impressora offline",
    "print": "Imprimir",
    "loadingWait": "Carregando, aguarde...",
    "selectAll": "Selecionar todos",
    "units": "unidade(s)",
    "printingLabels": "Imprimindo {{count}} etiqueta(s), aguarde...",
    "status": {
      "all": "Todos",
      "pending": "Pendente",
      "readyToShip": "Pronto para Enviar",
      "shipped": "Enviado",
      "delivered": "Entregue",
      "notDelivered": "Não Entregue",
      "cancelled": "Cancelado",
      "inTransit": "Em Trânsito"
    },
    "col": {
      "id": "Identificador",
      "product": "Produto",
      "attributes": "Atributos",
      "sku": "SKU",
      "status": "Status",
      "manufacturingEnd": "Data de Conclusão da Fabricação",
      "price": "Preço",
      "quantity": "Quantidade"
    }
  },
  "sellerOrders": {
    "title": "Pedidos",
    "subtitle": "Visualize os pedidos do seller por período",
    "startDate": "Data Inicial",
    "endDate": "Data Final",
    "search": "Pesquisar",
    "rangeHint": "Intervalo máximo de 7 dias.",
    "total": "Total de pedidos:",
    "loading": "Carregando, aguarde...",
    "empty": "Nenhum pedido encontrado para o período selecionado.",
    "page": "Página {{current}} de {{total}}",
    "previous": "Anterior",
    "next": "Próximo",
    "col": {
      "orderId": "Pedido",
      "date": "Data",
      "buyer": "Comprador",
      "product": "Produto",
      "items": "Itens",
      "quantity": "Qtd.",
      "status": "Status",
      "total": "Total"
    },
    "errors": {
      "required": "Informe a data inicial e final.",
      "endBeforeStart": "A data final não pode ser anterior à data inicial.",
      "rangeTooLarge": "O intervalo máximo permitido é de {{max}} dias.",
      "loadError": "Erro ao carregar os pedidos."
    }
  },
  "invoices": {
    "title": "LISTAGEM DE FATURAS",
    "totalCount": "Total: {{count}} faturas",
    "empty": "Nenhuma fatura encontrada.",
    "invoiceLabel": "Fatura",
    "totalAmount": "Valor Total",
    "due": "Venc:",
    "overdue": "VENCIDA",
    "itemsCount": "{{count}} item(ns)",
    "payNow": "Pagar agora",
    "clickForDetails": "Clique para ver detalhes",
    "loadingMore": "Carregando mais faturas...",
    "status": {
      "pending": "Pendente",
      "issued": "Emitida",
      "paid": "Paga",
      "cancelled": "Cancelada",
      "unknown": "Desconhecido"
    },
    "detail": {
      "overdueTitle": "FATURA VENCIDA",
      "overdueText": "Esta fatura está vencida e requer atenção imediata.",
      "details": "Detalhes da Fatura",
      "number": "Número:",
      "qrTitle": "QR Code para Pagamento",
      "paymentConfirmed": "Pagamento Confirmado!",
      "paymentConfirmedSuccess": "Pagamento confirmado com sucesso!",
      "moreDetails": "+detalhes",
      "createdDate": "Data de Criação",
      "dueDate": "Data de Vencimento",
      "lastUpdate": "Última Atualização",
      "invoiceItems": "Itens da Fatura",
      "colDescription": "Descrição",
      "colValue": "Valor",
      "totalLabel": "Total:",
      "noItems": "Nenhum item encontrado nesta fatura.",
      "backToDetails": "Voltar aos Detalhes"
    },
    "payment": {
      "title": "Dados para Pagamento",
      "email": "Email",
      "firstName": "Primeiro Nome",
      "lastName": "Sobrenome"
    },
    "errors": {
      "emailRequired": "Email é obrigatório",
      "emailInvalid": "Email inválido",
      "firstNameRequired": "Primeiro nome é obrigatório",
      "lastNameRequired": "Sobrenome é obrigatório"
    },
    "toast": {
      "noViewPermission": "Você não tem permissão para visualizar faturas.",
      "noPayPermission": "Você não tem permissão para pagar faturas.",
      "qrError": "Erro ao gerar QR Code. Tente novamente."
    }
  },
  "qrScanner": {
    "title": "SCANNER QR CODE",
    "connectToSession": "Conectar à Estação",
    "pairing": "Conectando à estação...",
    "station": "Estação",
    "typeOnDesktop": "Digite este número no computador para liberar este celular:",
    "waitingConfirmation": "Aguardando confirmação... {{seconds}}s",
    "codeOnlyHere": "Este número aparece só neste aparelho.",
    "stationOffline": "O computador da estação está desconectado.",
    "stationOfflineHint": "Você continua pareado. Assim que ele voltar, é só seguir bipando.",
    "initializingCamera": "Inicializando câmera...",
    "cameraDenied": "Permissão da câmera negada. Por favor, permita o acesso à câmera nas configurações do navegador.",
    "scanSessionInstruction": "Escaneie o QR Code exibido na tela do computador para conectar seu celular à sessão de scanner.",
    "scanning": "Escaneando...",
    "scanQrCode": "Escanear QR Code",
    "sendingQrCode": "Enviando QR Code...",
    "stopScanner": "Parar Scanner",
    "startScanner": "Iniciar Scanner",
    "sessionConnected": "Sessão conectada",
    "disconnect": "Desconectar",
    "sendHistory": "Histórico de Envios",
    "noSendsYet": "Nenhum QR Code enviado ainda",
    "sent": "Enviado",
    "errorShort": "Erro",
    "toast": {
      "titleScanner": "Scanner",
      "titleError": "Erro",
      "qrSent": "QR Code enviado com sucesso",
      "qrSendError": "Erro ao enviar QR Code",
      "sessionDisconnectedByServer": "Sessão desconectada pelo servidor",
      "initScannerError": "Erro ao inicializar scanner. Recarregue a página e tente novamente.",
      "cameraDenied": "Permissão da câmera negada. Por favor, permita o acesso à câmera nas configurações do navegador.",
      "cameraDeniedShort": "Permissão da câmera negada. Por favor, permita o acesso à câmera.",
      "cameraNotFound": "Câmera não encontrada. Verifique se o dispositivo possui câmera e se está disponível.",
      "scannerStartError": "Erro ao iniciar scanner: {{error}}",
      "connected": "Conectado à estação {{code}}",
      "connectError": "Erro ao conectar à estação. Leia o QR Code da tela do computador novamente.",
      "pairError": "Não foi possível parear com a estação. Leia o QR Code novamente.",
      "sessionGone": "A estação encerrou a sessão. Leia o QR Code novamente para reconectar.",
      "invalidStationQr": "Este QR Code não é de uma estação do Flowtify.",
      "stationOffline": "O computador da estação saiu do ar. Aguarde ele voltar.",
      "stationBack": "Estação de volta. Pode continuar bipando.",
      "qrSentData": "QR Code enviado: {{data}}"
    }
  },
  "checklist": {
    "tabInitial": "Inicial",
    "tabCreateEdit": "Criar/Editar",
    "tabScan": "Bipar",
    "title": "PESQUISA PARA ORDEM DE PRODUÇÃO",
    "startDate": "Data Início",
    "endDate": "Data Final",
    "search": "Pesquisar",
    "createOrder": "Criar Ordem",
    "pendingOrdersSuffix": "PEDIDOS PENDENTES",
    "colSaleNumber": "Número da Venda",
    "colDescription": "Descrição",
    "colQtItems": "QT Items",
    "colSku": "SKU",
    "colStatus": "Status",
    "colCreatedDate": "Data de Criação",
    "colEndDate": "Data Final",
    "createOrEdit": "Criar ou Editar",
    "createEditContent": "Este é o conteúdo da aba Criar/Editar.",
    "toast": {
      "searchError": "Ocorreu um erro ao buscar os pedidos, tente novamente.",
      "orderCreated": "Ordem de produção criada com sucesso, acesse a tela de Ordens de Produção para visualizar os detalhes.",
      "orderCreateError": "Ocorreu um erro ao criar a ordem de produção, tente novamente.",
      "selectAtLeastOne": "Selecione ao menos 1 pedido para criar a ordem de produção."
    }
  },
  "productGroup": {
    "filterTitle": "Filtrar Grupos de Produção",
    "namePlaceholder": "Nome do Grupo",
    "all": "Todos",
    "active": "Ativo",
    "inactive": "Inativo",
    "search": "Buscar",
    "createNew": "Criar Novo",
    "colName": "Nome",
    "colProducts": "Produtos",
    "colActive": "Ativo",
    "colDate": "Data",
    "colActions": "Ações",
    "edit": "Editar",
    "activate": "Ativar",
    "deactivate": "Inativar",
    "createTitle": "Criar Grupo de Produtos",
    "groupName": "Nome do Grupo",
    "groupNamePlaceholder": "Digite o nome do grupo",
    "nameRequired": "O nome do grupo é obrigatório.",
    "selectProduct": "Selecione um Produto",
    "filterProductsPlaceholder": "Digite para filtrar produtos",
    "addProduct": "Adicionar Produto",
    "selectedProducts": "Produtos Selecionados",
    "colProduct": "Produto",
    "remove": "Remover",
    "atLeastOneProduct": "O grupo precisa ter pelo menos um produto.",
    "toast": {
      "activated": "Grupo de produtos foi ativado com sucesso",
      "deactivated": "Grupo de produtos foi inativado com sucesso",
      "toggleError": "Ocorreu um erro ao alterar o status do grupo de produto.",
      "loadError": "Erro ao carregar o grupo de produtos.",
      "created": "Grupo adicionado com sucesso!",
      "createError": "Ocorreu um erro ao criar o grupo de produtos, tente novamente.",
      "updated": "Grupo atualizado com sucesso!",
      "updateError": "Ocorreu um erro ao atualizar o grupo de produtos."
    }
  },
  "charts": {
    "updatedAt": "Atualizado em",
    "period": "Período",
    "last7": "Últimos 7 dias",
    "last15": "Últimos 15 dias",
    "last30": "Últimos 30 dias",
    "allTime": "Vida toda",
    "top": "Top",
    "visualization": "Visualização",
    "quantitySold": "Quantidade vendida",
    "quantityCancelled": "Quantidade cancelada",
    "topSelling": "Produtos mais vendidos",
    "topSellingTreemap": "Produtos mais vendidos (Treemap)",
    "topSellingDonut": "Produtos mais vendidos (Donut)",
    "topCancelled": "Produtos mais cancelados",
    "topCancelledTreemap": "Produtos mais cancelados (Treemap)",
    "topCancelledDonut": "Produtos mais cancelados (Donut)",
    "thisWeek": "Esta Semana",
    "lastWeek": "Semana Passada",
    "salesComparison": "Comparação de Vendas",
    "startDate": "Data Início",
    "tooltipDate": "Data:",
    "days": {
      "mon": "Seg",
      "tue": "Ter",
      "wed": "Qua",
      "thu": "Qui",
      "fri": "Sex",
      "sat": "Sáb",
      "sun": "Dom"
    }
  },
  "forgotPassword": {
    "title": "Esqueci minha senha",
    "subtitle": "Digite seu email para receber um link de redefinição",
    "email": "Email",
    "emailPlaceholder": "Digite seu email",
    "sendLink": "Enviar link de redefinição",
    "sending": "Enviando...",
    "backToLogin": "Voltar para login",
    "successText": "Se o email existir em nosso sistema, você receberá um link para redefinir sua senha em alguns instantes.",
    "toast": {
      "emailRequired": "Email é obrigatório",
      "emailInvalid": "Email inválido. Por favor, verifique o email informado.",
      "connectionError": "Erro de conexão. Por favor, verifique sua internet e tente novamente.",
      "sendError": "Erro ao enviar email. Por favor, tente novamente."
    }
  },
  "resetPassword": {
    "title": "Redefinir senha",
    "subtitle": "Digite sua nova senha",
    "validatingLink": "Validando link...",
    "newPassword": "Nova Senha",
    "newPasswordPlaceholder": "Digite sua nova senha (mínimo 6 caracteres)",
    "confirmPassword": "Confirmar Senha",
    "confirmPasswordPlaceholder": "Confirme sua nova senha",
    "submit": "Redefinir Senha",
    "submitting": "Redefinindo...",
    "successText": "Senha redefinida com sucesso! Você já pode fazer login com sua nova senha.",
    "requestNewLink": "Solicitar novo link",
    "toast": {
      "linkInvalid": "Link inválido. Por favor, verifique o link ou solicite um novo.",
      "linkExpired": "Este link não é mais válido. Por favor, solicite um novo link de redefinição.",
      "validateError": "Erro ao validar link. Por favor, tente novamente ou solicite um novo link.",
      "connectionError": "Erro de conexão. Por favor, verifique sua internet e tente novamente.",
      "passwordRequired": "Senha é obrigatória",
      "passwordMin": "A senha deve ter no mínimo 6 caracteres",
      "passwordMax": "A senha deve ter no máximo 100 caracteres",
      "confirmRequired": "Confirmação de senha é obrigatória",
      "passwordsMismatch": "As senhas não coincidem. Por favor, verifique e tente novamente.",
      "resetError": "Erro ao redefinir senha. Por favor, verifique os dados e tente novamente.",
      "resetErrorRetry": "Erro ao redefinir senha. Por favor, tente novamente."
    }
  },
  "noPermission": {
    "title": "Acesso Restrito",
    "message": "Você não possui as permissões necessárias para acessar esta aplicação.",
    "contactAdmin": "Entre em contato com o administrador do sistema para solicitar as permissões adequadas.",
    "logoutAndLogin": "Sair e Fazer Login Novamente"
  },
  "landing": {
    "header": {
      "viewPlans": "Ver Planos",
      "access": "Acessar Sistema"
    },
    "hero": {
      "subtitle": "Imprima etiquetas com um bip e acelere sua operação",
      "description": "Bip o QR code e imprima a etiqueta instantaneamente. Nada de fazer download de arquivo, copiar texto ou processos complicados. Simples, rápido e direto."
    },
    "features": {
      "title": "Funcionalidades Principais",
      "subtitle": "Tudo que você precisa para gerenciar suas vendas de forma eficiente",
      "dashboardTitle": "Dashboard Inteligente",
      "dashboardDesc": "Visualize gráficos e métricas estratégicas em tempo real. Acompanhe produtos mais vendidos, cancelamentos e performance de vendas.",
      "bipTitle": "Impressão com Bip de QR Code",
      "bipHighlight": "Funcionalidade principal:",
      "bipDesc": "Bip o QR code e imprima a etiqueta instantaneamente. Nada de fazer download de arquivo, copiar texto ou processos complicados. Simples, rápido e direto ao ponto.",
      "scannerTitle": "Scanner QR Code",
      "scannerDesc": "Use seu dispositivo móvel como scanner. Escaneie códigos QR rapidamente para agilizar processos.",
      "invoicesTitle": "Faturas de Cobrança",
      "invoicesDesc": "Acompanhe suas faturas de cobrança do Flowtify. Visualize valores, vencimentos e mantenha controle sobre sua assinatura do serviço.",
      "mlTitle": "Integração Mercado Livre",
      "mlDesc": "Conecte-se facilmente com sua conta do Mercado Livre. Login rápido e seguro com OAuth."
    },
    "roadmap": {
      "title": "Roadmap Q1 2026",
      "subtitle": "Funcionalidades que estão chegando em breve",
      "stockTitle": "Controle de Estoque",
      "stockDesc": "Gerencie seu estoque de forma inteligente com controle completo de entrada, saída e movimentações.",
      "productionTitle": "Produção",
      "productionDesc": "Acompanhe e gerencie sua produção com ordens de produção, checklist e controle de qualidade.",
      "priceTitle": "Calculadora de Preço",
      "priceDesc": "Calcule preços de venda de forma precisa considerando custos, margens e comissões do Mercado Livre."
    },
    "plans": {
      "title": "Escolha o Plano Ideal",
      "subtitle": "Planos flexíveis para atender seu negócio",
      "popular": "Popular",
      "premium": "Premium",
      "perMonth": ",99 por mês",
      "subscribe": "Contratar",
      "labelPrinting": "Impressão de etiquetas",
      "perMonthCount": "{{count}} por mês",
      "unlimited": "Ilimitado",
      "dashboard": "Dashboard",
      "cancelledMetrics": "Métricas de vendas canceladas",
      "topSales": "Top vendas",
      "weeklyComparison": "Comparativo semanal de vendas",
      "production": "Produção",
      "mlChat": "Chat integrado ML",
      "aiIntegrated": "IA integrada",
      "stockControl": "Controle de Estoque",
      "priceCalculator": "Calculadora de preços"
    },
    "benefits": {
      "title": "Por que escolher o FLOWTIFY?",
      "timeTitle": "Economia de Tempo",
      "timeDesc": "Automatize processos repetitivos e foque no que realmente importa para o seu negócio.",
      "securityTitle": "Segurança",
      "securityDesc": "Seus dados protegidos com as melhores práticas de segurança e integração segura com Mercado Livre.",
      "multiplatformTitle": "Multiplataforma",
      "multiplatformDesc": "Acesse de qualquer dispositivo. Funciona perfeitamente em desktop, tablet e mobile.",
      "insightsTitle": "Insights Inteligentes",
      "insightsDesc": "Tome decisões baseadas em dados. Gráficos e relatórios detalhados para análise estratégica."
    },
    "cta": {
      "title": "Pronto para otimizar suas vendas?",
      "description": "Comece a usar o FLOWTIFY hoje mesmo e transforme a forma como você gerencia suas vendas no Mercado Livre.",
      "access": "Acessar Sistema"
    }
  }
}
